import { render, staticRenderFns } from "./PuzzleWordMark.vue?vue&type=template&id=3ecab156&scoped=true&"
import script from "./PuzzleWordMark.vue?vue&type=script&lang=ts&"
export * from "./PuzzleWordMark.vue?vue&type=script&lang=ts&"
import style0 from "./PuzzleWordMark.vue?vue&type=style&index=0&id=3ecab156&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecab156",
  null
  
)

export default component.exports